import { SingleValue } from "react-select";
import { Maybe } from "../types/maybe.ts";

type SelectItemType = {
  label: string;
  value: string;
};

export type TransformSelectInput = {
  input: (input: Maybe<string>) => Maybe<SelectItemType>;
  output: (output: SingleValue<SelectItemType>) => Maybe<string>;
};

export const transformSelectInput: TransformSelectInput = {
  input: (input: Maybe<string>): Maybe<SelectItemType> => {
    if (input == null) {
      return null;
    }

    return {
      label: input,
      value: input,
    };
  },
  output: (output: SingleValue<SelectItemType>): Maybe<string> => {
    if (output == null) {
      return null;
    }

    return output.label;
  },
};
